import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMarketAreas, deleteMarketArea, changeDefaultStatus } from './marketAreaSlice';
import { Container, Modal, Toast, Button } from "react-bootstrap";
import Input from "../../components/input";
// import CommonButton from "../../components/commonButton";
import CommonPagination from "../../components/commonPagination";
import CommonTable from '../../components/commonTable';
// import { Add01Icon } from "../../assets/icons";
import { useLoader } from "../../context/LoaderContext";
// import MarketAreaAdd from './MarketAreaAdd';
// import MarketAreaEdit from './MarketAreaEdit';
// import MarketAreaView from './MarketAreaView';

const MarketAreaList = () => {

  const dispatch = useDispatch();
  const { setLoading } = useLoader();
  const { marketAreas } = useSelector((state) => state.marketAreas);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
//   const [showModal, setShowModal] = useState(false);
  const [selectedMarketAreaId, setSelectedMarketAreaId] = useState('');
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarVariant, setSnackbarVariant] = useState("success");
  const limit = 10;
  const totalPages = Math.ceil(marketAreas?.total_records / limit);
  const total = marketAreas?.total_records || 0;

  const token = localStorage.getItem('auth-token');

  useEffect(() => {
    const fetchMarketAreas = async () => {
      setLoading(true);
      const payload = {
        page: currentPage,
        search: searchTerm,
        limit: limit,
        token
      };
  
      try {
        if (token) {
          await dispatch(getMarketAreas({ payload }));
        }
      } catch (error) {
        setLoading(false);
        console.error("Error fetching marketAreas:", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchMarketAreas();
  }, [dispatch, token, currentPage, searchTerm, setLoading]);
  

  const columns = [
    { label: 'country', key: 'country.name' },
    { label: 'state', key: 'state.name' },
    { label: 'City', key: 'city.name' },
    { label: 'Type', key: 'type' },
    { label: 'created at', key: 'created_at', type: 'date' },
    {label: 'Default', key: 'is_default', type: 'default' },
  ];

  const handlePageChange = (newPageNumber) => {
    setCurrentPage(newPageNumber);
  };

  const handleDeleteNew = async () => {
    if (selectedMarketAreaId) {
      await dispatch(deleteMarketArea(selectedMarketAreaId)).then((res) => {
        if(res.payload.success) {
          setShowDeleteModal(false);
          setSnackbarMessage(res.payload.message);
          setSnackbarVariant("success");
          setShowSnackbar(true);
          const payload = {
            page: currentPage,
            search: searchTerm,
            limit: limit,
            token
          };
          dispatch(getMarketAreas({ payload }));
        } else {
          setShowDeleteModal(false);
          setSnackbarMessage(res.payload.message);
          setSnackbarVariant("danger");
          setShowSnackbar(true);
        }
      });
    }
  };

  const handleEdit = (row) => {
    // setSelectedMarketAreaId(row.id);
    handleOpen();

  };

  const handleOpen = () => {
    setTimeout(() => {
    //   setShowEditModal(true);
    }, 1000);
  };
  

  const handleDelete = (row) => {
    setSelectedMarketAreaId(row.id);
    setShowDeleteModal(true);
  };

  const handleView = (row) => {
    setSelectedMarketAreaId(row.id);
    // setShowViewModal(true);
  };

  const handleStatusChange = async (id) => {
    setSelectedMarketAreaId(id);
    setShowStatusModal(true);
  }

  const handleStatusChangeNew = async () => {
    await dispatch(changeDefaultStatus(selectedMarketAreaId)).then((res) => {
      if(res.payload.success) {
        setShowStatusModal(false);
        setSnackbarMessage(res.payload.message);
        setSnackbarVariant("success");
        setShowSnackbar(true);
        const payload = {
          page: currentPage,
          search: searchTerm,
          limit: limit,
          token
        };
        dispatch(getMarketAreas({ payload }));
      } else {
        setShowStatusModal(false);
        setSnackbarMessage(res.payload.message);
        setSnackbarVariant("danger");
        setShowSnackbar(true);
      }
    });
  }

  return (
    <>
      <Container fluid className="px-0">
        {/* <MarketAreaAdd 
          show={showModal}
          // onHide={() => setShowModal(false)}
          handleClose={() => setShowModal(false)}
          currentPage={currentPage}
          searchTerm={searchTerm}
          limit={limit}
        />
        <MarketAreaEdit
          marketAreaId={selectedMarketAreaId}
          show={showEditModal}
          // onHide={() => setShowEditModal(false)}
          handleClose={() => setShowEditModal(false)}
          currentPage={currentPage}
          searchTerm={searchTerm}
          limit={limit}
        />
        <MarketAreaView
          show={showViewModal}
          handleClose={() => setShowViewModal(false)}
          marketAreaId={selectedMarketAreaId} 
        /> */}

        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to delete this Target Region?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
              Cancel
            </Button>
            <Button variant="danger" onClick={handleDeleteNew}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showStatusModal} onHide={() => setShowStatusModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Default Update</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to make default this Target Region?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowStatusModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleStatusChangeNew}>
              Change
            </Button>
          </Modal.Footer>
        </Modal>

        <Toast
          onClose={() => setShowSnackbar(false)}
          show={showSnackbar}
          delay={3000}
          autohide
          bg={snackbarVariant}
          style={{ position: "fixed", top: 20, right: 20, zIndex: 1000 }}
        >
          <Toast.Body style={{ color: "white" }}>{snackbarMessage}</Toast.Body>
        </Toast>

        <div className="p-4 d-flex align-items-center justify-content-between gap-4">
          <Input
            type="search"
            value={searchTerm}
            placeholder="Search Target Region"
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1);
            }}
            className="shadow-none base-search"
          />

          {/* <CommonButton
            icon={<Add01Icon width={16} height={16} color="#ffffff" strokeWidth="2" />}
            title="Add Target Region"
            className="btn-primary common-one-shadow"
            onClick={() => {
              setShowModal(true);
            }}
          /> */}
        </div>

        <div className="bg-white rounded-2 overflow-hidden common-shadow">
            <CommonTable
              columns={columns}
              data={marketAreas?.data || []}
              url={marketAreas?.url || []}
              showActions={false}
              showButton={true}
              actions={{
                showEdit: true,
                showDelete: true,
                showView: true,
                onEdit: handleEdit,
                onDelete: handleDelete,
                onView: handleView
              }}
              onStatusChange={handleStatusChange}
            />
        </div>

        <div className="p-3 mx-1 d-flex flex-wrap align-items-center justify-content-between gap-4">
          <p className="custom-table-infotext">
            Displaying {(limit * (currentPage - 1)) + 1} to {Math.min(limit * currentPage, total)} of {total} Target Regions
          </p>

          <div>
            {totalPages > 1 ? (
              <CommonPagination
                totalItems={total}
                itemsPerPage={limit}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            ) : null}
          </div>
        </div>
      </Container>
    </>
  );
};

export default MarketAreaList;
